module.exports = __webpack_public_path__ + "static/media/desktop-alt.3588fd4b.svg";